import { Component } from '@angular/core'

@Component({
    selector: 'sf-tracking-unavailable',
    imports: [],
    templateUrl: './tracking-unavailable.component.html',
    styleUrl: './tracking-unavailable.component.scss',
})
export class TrackingUnavailableComponent {}
